import React from 'react'
import ReactDOM from 'react-dom';

import heroImage from '../img/pharma.png'

import requestDemo from '../img/request-demo.svg'
import chevron from '../img/chevron.svg';
import universe_qrcode from '../img/universe_qrcode.jpg';

import { httpRequest } from '../core_classes/http.js';

import msg_alert from '../configs/msg_central.json';

import DataTable from 'react-data-table-component';

class AboutComponent extends React.Component {

	render() {
        return (
        	<section id="about" class="about-holder">
	            <div class="container">
	                <div class="about-content">
	                    <h2>Our Pharmacy</h2>
	                    <p>Serving you quality drugs, Since 1989.</p>
	                    <img src={heroImage} />
	                </div>
	            </div>
	        </section>
        );
    }
}//end class

class BenefitComponent extends React.Component {

	render() {
        return (
        	<section id="benefits" class="benefits-holder">
	            <div class="container">
	                <div class="row">
	                    <div class="col-12 col-md-4">
	                        <div class="benefit">
	                            <div class="benefit-icon" aria-hidden="true">
	                                <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
	                                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
	                                    <path d="m9 12 2 2 4-4" />
	                                </svg>
	                            </div>
	                            <h4>Safety</h4>
	                            <p>
	                                We check and double check your every order before it leaves our store, ensuring your health and safety.
	                            </p>
	                        </div>
	                    </div>
	                    <div class="col-12 col-md-4">
	                        <div class="benefit">
	                            <div class="benefit-icon" aria-hidden="true">
	                                <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
	                                    <rect x="5" y="2" width="14" height="5" rx="1" />
	                                    <path d="M6 7v12a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V7" />
	                                    <path d="M6 12h12" />
	                                    <path d="M6 16h12" />
	                                </svg>
	                            </div>
	                            <h4>Wide range of medicines</h4>
	                            <p>
	                                We keep a constant inventory of any brand you prefer or what your doctor recommends.
	                            </p>
	                        </div>
	                    </div>
	                    <div class="col-12 col-md-4">
	                        <div class="benefit">
	                            <div class="benefit-icon" aria-hidden="true">
	                                <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
	                                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
	                                    <path d="M8 10h.01" />
	                                    <path d="M12 10h.01" />
	                                    <path d="M16 10h.01" />
	                                </svg>
	                            </div>
	                            <h4>Communication</h4>
	                            <p>
	                                You can easily reach us anytime and our staff will gladly serve you with a smile.
	                            </p>
	                        </div>
	                    </div>
	                </div>
	            </div>
	        </section>
        );
    }
}//end class


class InquiryFormComponent extends React.Component {
	constructor(props) {
        super();
        this.state = { 
            "inquiryForm": {
                'name': '',
                'email': '',
				'contact': '',
                'subject': '',
                'inquiryBody': ''
            }
        };
    	
        this.inquiryRequest = new httpRequest('v1/public/inquiry', 'POST', this.state['inquiryForm']);
        
        //refs
        this.formRefs = {};
        Object.keys(this.state['inquiryForm']).forEach((elem_indx) => { 
			this.formRefs[elem_indx] = React.createRef();
		});

        //functions
    	this.sendInquiry = this.sendInquiry.bind(this);
		
		//exported files
		this.msg_alerts = msg_alert;
    }//end constructor


    updateForm = (e) => {
		if(typeof e.name !== 'undefined'){
			let newInquiryForm = this.state['inquiryForm'];
			
			if(e.name == "email"){
				if(this.formValidate(e.name, e.value)){
					this.formRefs[e.name].current.style.border = "";
					ReactDOM.render('', document.getElementById('email_validity_notif'));
				}else{
					this.formRefs[e.name].current.style.border = "solid 2px red";
					ReactDOM.render(this.msg_alerts.email_not_valid, document.getElementById('email_validity_notif'));
				}//end if
			}//end if

			newInquiryForm[e.name] = e.value;
			this.setState({
	            "inquiryForm": newInquiryForm
	        });
		}//end if
    }//end fn

   	sendInquiry = (event) => {
   		var empty_fields = [];
   		let alertMessage = '';
   		let email_isvalid = false;

   		Object.keys(this.state['inquiryForm']).forEach((elem_indx) => { 
            if(this.state['inquiryForm'][elem_indx] == ""){
            	empty_fields.push(elem_indx);
            }//end if
        });
		

		if(empty_fields.length != 0){
    		alertMessage = <div class="alert alert-danger" role="alert">{ this.msg_alerts.inquiry_form_error }</div>;
			empty_fields.forEach((x) => {
				this.formRefs[x].current.style.border = "solid 2px red";
			});
		}//end if
		
		if(this.state['inquiryForm']['email'] != ""){
			if(this.formValidate('email', this.state['inquiryForm']['email'])){
				this.formRefs['email'].current.style.border = "";
				email_isvalid = true;
			}else{
				alertMessage = <div class="alert alert-danger" role="alert">{ this.msg_alerts.email_not_valid }</div>;
				this.formRefs['email'].current.style.border = "solid 2px red";
				ReactDOM.render(this.msg_alerts.email_not_valid, document.getElementById('email_validity_notif'));
				email_isvalid = false;
			}//end if
		}//end if

		if(empty_fields.length == 0 && email_isvalid){
			this.inquiryRequest.send();
			Object.keys(this.state['inquiryForm']).forEach((elem_indx) => { 
				this.formRefs[elem_indx].current.style.border = "";
			});
			alertMessage = <div class="alert alert-success" role="alert" >{ this.msg_alerts.inquiry_success_send }!</div>;
			ReactDOM.render('', document.getElementById('email_validity_notif'));
			this.clearForm();
		}//end fn
		
		ReactDOM.render(alertMessage, document.getElementById('userAlerts'));
    }//end fn


    clearForm(){
    	Object.keys(this.state['inquiryForm']).forEach((elem_indx) => { 
            let newInquiryForm = this.state['inquiryForm'];
            newInquiryForm[elem_indx] = '';
			this.setState({
	            "inquiryForm": newInquiryForm
	        });
        });
    }//end fn

    formValidate(fieldtype, form_value){
    	switch(fieldtype){
    		case 'email':
    			const regex = new RegExp('^[A-Za-z0-9\\u0430-\\u044F\\u0410-\\u042F\\._-]+@([A-Za-z0-9\\u0430-\\u044F\\u0410-\\u042F]{1,2}|[A-Za-z0-9\\u0430-\\u044F\\u0410-\\u042F]((?!(\\.\\.))[A-Za-z0-9\\u0430-\\u044F\\u0410-\\u042F.-])+[A-Za-z0-9\\u0430-\\u044F\\u0410-\\u042F])\\.[A-Za-z\\u0430-\\u044F\\u0410-\\u042F]{2,}$');    
    			return regex.test(form_value);
    		break;

    		default:
    			return true;
    		break;
    	}//end switch
    }///end fn

	render() {
       	return (
       		<section id="reqs" class="reqs-holder">
	            <div class="container">
	                <h2 class="title">Send us your Inquiry!</h2>
	                <p class="p">
	                    We would like to hear from you!
	                </p>
	                <div class="row">
	                	<div class="col-md-12" id="userAlerts">
							{/*
							<div class="alert alert-danger" role="alert">
							  This is a danger alert—check it out!
							</div>*/}
						</div>
	                    <div class="col-12 col-md-6">
	                        <div class="demo-form">
	                            <div class="demo-grp">
	                                <label>Name</label>
	                                <input type="text" data-shit="datashit" name="name" ref={ this.formRefs['name'] } placeholder="Enter your Name" class="form-control" value={ this.state['inquiryForm']['name'] } onChange={(e) => this.updateForm(e.currentTarget)}/>
	                            </div>
	                            <div class="demo-grp">
	                                <label>Email Address</label>
	                                <input type="text" name="email" ref={ this.formRefs['email'] } placeholder="Enter your Email" class="form-control" value={ this.state['inquiryForm']['email'] } onChange={(e) => this.updateForm(e.currentTarget)}/>
	                                <span class="emailErrorNotify" id="email_validity_notif"></span>
	                            </div>
								<div class="demo-grp">
	                                <label>Contact #</label>
	                                <input type="text" name="contact" ref={ this.formRefs['contact'] } placeholder="Enter your contact #" class="form-control" value={ this.state['inquiryForm']['contact'] } onChange={(e) => this.updateForm(e.currentTarget)}/> 
	                            </div>
	                            <div class="demo-grp">
	                                <label>Subject</label>
	                                <input type="text" name="subject" ref={ this.formRefs['subject'] } placeholder="Enter what is your inquiry about" class="form-control" value={ this.state['inquiryForm']['subject'] } onChange={(e) => this.updateForm(e.currentTarget)}/> 
	                            </div>
	                            <div class="demo-grp">
	                                <label>Inquiry Details</label>
	                                <textarea name="inquiryBody" ref={ this.formRefs['inquiryBody'] } id="inquirybody" cols="30" rows="10" class="inquiryform_textarea form-control" value={ this.state['inquiryForm']['inquiryBody'] } onChange={(e) => this.updateForm(e.currentTarget)}></textarea>
	                            </div>

	                            <div class="demo-grp">
	                                <button class="bt bt-send" onClick={this.sendInquiry}>Send Request</button>
	                            </div>
	                        </div>
	                    </div>
	                    <div class="col-12 col-md-6">
	                        <div class="demo-img">
	                            <img src={requestDemo} />
	                        </div>
	                    </div>
	                </div>
	            </div>
	        </section>
       	);
    }
}//end class

class GoogleFormInquiry extends React.Component {
	render(){
		return (
			<section id="reqs" class="reqs-holder">
	            <div class="container">
	                <h2 class="title">Send us your Inquiry!</h2>
	                <p class="p">
	                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.
	                </p>
	                <div class="row">
	                	<iframe src="https://docs.google.com/forms/d/e/1FAIpQLSezcp05jSSOC6s4HgXbPUIjxUz564vkK1dEXqC5aWaHbLsEtQ/viewform?embedded=true" width="100%" height="984" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
	                </div>
	            </div>
	        </section>
	    );
	}//end
}//end class

class ContactDetailsComponent extends React.Component {
	render() {
        return (
        	<section id="pricing" class="pricing-holder">
	            <div class="container">
				    <h2 class="title">CONTACT DETAILS</h2>
				    <br />
				    <div class="row">
				        <div class="col-md-6">
				        	<h4 class="contact-detail-header">MAP</h4>
				            <div class="mapouter"><div class="gmap_canvas"><iframe width="100%" height="500" id="gmap_canvas" src="https://maps.google.com/maps?q=Universe%20Pharmacy&t=&z=17&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="yes" marginheight="0" marginwidth="0"></iframe></div></div>
				        </div>
				        <br />
				        <div class="col-md-6">
			                <div class="form-group">
			                    <h4 class="contact-detail-header">UNIVERSE PHARMACY</h4>
			                    <label class="contact-details-labels">366 Magallanes Street</label><br/>
			                    <label class="contact-details-labels">Barangay Ermita, Cebu City</label><br/>
			                    <label class="contact-details-labels">Philippines 6000</label>
			                </div>
			                <div class="form-group">
			                    <h4 class="contact-detail-header2">TELEPHONE #</h4>
			                    <label class="contact-details-labels">(032) 253-4819 / 253-0146 / 268-8946</label>
			                </div>
			                <div class="form-group">
			                    <h4 class="contact-detail-header2">MOBILE</h4>
			                    <label class="contact-details-labels">(0961) 030 0777 / (0955) 449 0930</label>
			                </div>
			                <div class="form-group">
			                    <h4 class="contact-detail-header2">EMAIL</h4>
			                    <label class="contact-details-labels">contact@universe.ph</label>
			                </div>
			                <div class="form-group">
			                    <h4 class="contact-detail-header2">STORE HOURS</h4>
			                    <label class="contact-details-labels">MONDAY to SATURDAY (8:30AM - 5:30PM)</label><br/>
								<label class="contact-details-labels">SUNDAY (CLOSED)</label>
			                </div>
			                <div class="form-group">
			                    <h4 class="contact-detail-header2">EMAIL</h4>
			                    <label class="contact-details-labels">contact@universe.ph</label>
			                </div>
				        </div>
				    </div>
				</div>
	        </section>
        );
    }
}//end class

class FAQComponent extends React.Component {
	render() {
        return (
        	<section id="faq" class="faq-holder">
	            <div class="container">
	                <h2 class="title">Frequently Asked Questions</h2>
	                <p class="p">
	                    Questions on Ordering and More...
	                </p>

	                <div class="question">
	                    <a data-toggle="collapse" href="#q1" aria-expanded="false" aria-controls="q1">How do I make an Order? <img class="" src={ chevron } /></a>
	                    <div class="collapse ans" id="q1">
	                        <p>
							You can visit our store anytime during our store hours.. You may call our phone numbers listed above, or send your orders to us at <b>contact@universe.ph</b> Alternatively, you may also call or leave a message ahead of time to book your order, and skip the queue. Pick up your order at your convenience, or if you're within Metro Cebu, we may be able to deliver it straight to you door
	                        </p>
	                    </div>
	                </div>

	                <div class="question">
	                    <a data-toggle="collapse" href="#q2" aria-expanded="false" aria-controls="q1">How do I order Wholesale Items with Wholesale Pricing? <img class="" src={ chevron } /></a>
	                    <div class="collapse ans" id="q2">
	                        <p>
	                            For large institutions like hospitals, or smaller pharmacy resellers, you may send your Purchase Order to our email address at <b>contact@universe.ph</b>
	                        </p>
	                    </div>
	                </div>

					<div class="question">
	                    <a data-toggle="collapse" href="#q4" aria-expanded="false" aria-controls="q1">What are the modes of payment available? <img class="" src={ chevron }/></a>
	                    <div class="collapse ans" id="q4">
							<p>
	                            You can pay via cash in-store, credit cards, online banking, or via the QR Code below:
	                        </p>
	                        <div class="row justify-content-center">
								<img class="thumbnail" width="600" src = { universe_qrcode } />
							</div>
	                    </div>
	                </div>

					<div class="question">
	                    <a data-toggle="collapse" href="#q3" aria-expanded="false" aria-controls="q1">Other questions or suggestions? Let us know <img class="" src={ chevron }/></a>
	                    <div class="collapse ans" id="q3">
	                        <p>
	                            If you have any other queries or suggestions, fell free to leave a message at contact@universe.ph, or leave a message at the form above and we will get back to you as soon as we can.
	                        </p>
	                    </div>
	                </div>
	            </div>
	        </section>
        );
    }
}//end class


// data provides access to your row data
const ExpandedComponent: React.FC<ExpanderComponentProps<DataRow>> = ({ data }) => {
    return <div class="data-details">
    <p class="primary"><b>Name:</b> { data.name } </p>
    <p class="secondary"><b>Email:</b> { data.email } </p>
    <p class="secondary"><b>Contact #:</b> { data.contact } </p>
	<p class="secondary"><b>Subject:</b> { data.subject } </p>
    <p class="secondary"><b>Inquiry Details:</b> { data.inquiryBody } </p>
	<p class="secondary"><b>Date Received:</b> { data.created_at } </p>
    </div>;
};

class INQPassword extends React.Component {
	constructor(props) {
        super();
        this.state = { 
            "inqpassword": '',
            'showInquiries': false,
            "datatable_data": []
        };

        this.datacols = [
			{
		        name: 'Sent',
		        selector: row => row.created_at,
		    },
        	{
		        name: 'Name',
		        selector: row => row.name,
		    },{
		        name: 'Email',
		        selector: row => row.email,
		    },{
		        name: 'Contact',
		        selector: row => row.contact,
		    },{
		        name: 'Subject',
		        selector: row => row.subject,
		    },{
		        name: 'Content',
		        selector: row => row.inquiryBody,
		    },
        ];
        
        //refs
        this.formRefs = {
        	'inqpassword': React.createRef()
        };

    }//end constructor

    componentDidMount() {
		//REUSE A TOKEN FROM EARLIER IN THIS BROWSER SESSION
		let token = null;
		try { token = sessionStorage.getItem('inqboard_token'); } catch (err) {}
		if(token){
			this.loadInquiries(token);
		}//end if
    }

    loadInquiries = (token) => {
		let request = new httpRequest('v1/private/inquiry', 'GET', null, { "Authorization": "Bearer " + token });
		request.send((data) => {
			this.setState({
				'datatable_data': data,
				'showInquiries': true
			});
		}, () => {
			try { sessionStorage.removeItem('inqboard_token'); } catch (err) {}
			this.setState({
				'showInquiries': false
			});
		});
    }//end fn

    processPassword = (e) => {
		if(typeof e.name !== 'undefined'){
			let inqpass = this.state['inqpassword'];
			
			inqpass = e.value;

			this.setState({
	            "inqpassword": inqpass
	        });
		}//end if
    }//end fn

    checkCredentials = (e) => {
    	let loginRequest = new httpRequest('v1/public/inqdash/login', 'POST', { "password": this.state['inqpassword'] });
    	loginRequest.send((data) => {
    		try { sessionStorage.setItem('inqboard_token', data.token); } catch (err) {}
    		this.loadInquiries(data.token);
    	}, (error) => {
    		if(error.response && error.response.status === 429){
    			alert('Too many attempts. Please try again later.');
    		}else{
    			alert('Password Incorrect');
    		}//end if
    	});
    }//end fn

	render() {
        return (
        	<div>
        		{ !this.state['showInquiries'] && (
	        	<div class="row justify-content-center">
		          <div class="col-6">
		              <div class="form-group">
		                <label>Password</label>
		                <div class="input-group" id="show_hide_password">
		                  <input name="inqpassword" class="form-control" type="password" onChange={(e) => this.processPassword(e.currentTarget)} />
		                </div>
		              </div>
		            <button class="btn btn-primary" onClick={(e) => this.checkCredentials(e.currentTarget)}>PROCEED</button>
		          </div>
		       	</div>)
		       	}
		       	{ this.state['showInquiries'] && (
		       	<div class="row">
		       		<div class="data-table-up col-md-12">
						<DataTable
						columns={this.datacols}
						data={this.state['datatable_data']}
						pagination
						expandableRows expandableRowsComponent={ExpandedComponent}
						/>
		         	</div>
		       	</div>)
		       	}
		    </div>
        );
    }
}//end class


export { AboutComponent,  BenefitComponent, InquiryFormComponent, ContactDetailsComponent, FAQComponent , GoogleFormInquiry, INQPassword};